/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
import { createSlice } from '@reduxjs/toolkit';
import { login } from '../actions/auth.action';
import { getUserInfo } from '../actions/users.action';

const initialState = {
  user: {},
  loginStatus: 'idle',
};

const authenticationSlice = createSlice({
  name: 'authentication',
  initialState,
  reducers: {
    logoutUser: (state) => {
      state.user = null;
      state.loginStatus = 'idle';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.fulfilled, (state, action) => {
        state.loginStatus = 'complete';
      })
      .addCase(login.pending, (state, action) => {
        state.loginStatus = 'loading';
      })
      .addCase(login.rejected, (state, action) => {
        state.loginStatus = 'failed';
      })

      .addCase(getUserInfo.fulfilled, (state, action) => {
        state.loginStatus = 'complete';
        state.user = action.payload;
      })
      .addCase(getUserInfo.pending, (state, action) => {
        state.loginStatus = 'loading';
      })
      .addCase(getUserInfo.rejected, (state, action) => {
        state.loginStatus = 'failed';
      });
  },
});

export const { logoutUser } = authenticationSlice.actions;

export default authenticationSlice.reducer;
